import { call, put, takeEvery } from 'redux-saga/effects'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'

import { API_URL_PATH_KEG_COLLECTION_BOOKINGS_SEARCH_FILTERS_OPTIONS } from '../../../../../constants'

import {
  saveKegCollectionBookingsListViewSearchFilterOptions,
  fetchKegCollectionBookingsListViewSearchFilterOptionsRequest,
  fetchKegCollectionBookingsListViewSearchFilterOptionsSuccess,
  fetchKegCollectionBookingsListViewSearchFilterOptionsFailure,
} from './utils'

import { FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS } from '../../../../actions/actionTypes'

function* fetchBookingsSearchFiltersOptionsWorker(action) {
  if (!action) return

  const { optionsParams } = action.payload || {}

  yield put(fetchKegCollectionBookingsListViewSearchFilterOptionsRequest())

  try {
    const response = yield call(privateFetch, {
      path: API_URL_PATH_KEG_COLLECTION_BOOKINGS_SEARCH_FILTERS_OPTIONS,
      params: optionsParams,
    })
    const searchFilterOptions = response?.data || {
      createdByUsers: [],
      assignedByUsers: [],
      states: [],
      postalCodes: [],
    }
    yield call(doSuccess, searchFilterOptions)
  } catch (error) {
    if (error.response?.status === 404) {
      yield call(doSuccess, {
        createdByUsers: [],
        assignedByUsers: [],
        states: [],
        postalCodes: [],
      })
      return
    }
    yield call(doFailure, error)
  }
}

export default [
  [
    takeEvery,
    FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS,
    fetchBookingsSearchFiltersOptionsWorker,
  ],
]

function* doSuccess(searchFilterOptions) {
  yield put(saveKegCollectionBookingsListViewSearchFilterOptions(searchFilterOptions))
  yield put(fetchKegCollectionBookingsListViewSearchFilterOptionsSuccess())
}

function* doFailure(error) {
  yield call(generalDoFailure, {
    error,
    action: fetchKegCollectionBookingsListViewSearchFilterOptionsFailure(error),
  })
}
